<template>
	<svg class="LogoLabSapsucker" :class="classes" viewBox="0 0 100 58" role="img" :aria-labelledby="id">
		<title :id="id">Cornell Lab sapsucker logo</title>
		<g class="LogoLabSapsucker-sapsucker" fill="none" fill-rule="evenodd" transform="translate(.812)">
			<path
				fill="#FFF"
				d="M95.135 8.519c-.79-.284-3.144-1.022-4.149-1.337-1.007-.32-3.866-1.145-4.7-1.396a8.265 8.265 0 0 0-.875-.977C82.637 1.867 78.417.112 74.116.112c-4.887 0-8.546 1.607-9.8 2.24H.513v1.8c0 2.708 3.132 4.75 7.287 4.75h17.584L39.62 18.926v15.376c0 7.584 4.011 14.444 10.724 18.359 5.619 3.278 9.007 3.54 12.85 3.54.276 0 .552-.003.837-.005.287 0 .579-.003.88-.003h1.805v-32l1.203-.883L83.56 11.82s8.221-.508 10.306-.642a69.848 69.848 0 0 0 3.374-.29c.837-.099 1.178-.363 1.178-.58 0-.261-.155-.364-.35-.51-.161-.122-1.402-.726-2.932-1.278z"
			/>
			<path
				fill="#000"
				d="M95.494 9.7s-7.422-1.953-10.276-2.203c0 0-11.293 6.073-14.456 8.114-3.168 2.04-3.77 5.107-3.91 6.25L82.97 10.02H95.6c.321 0-.107-.322-.107-.322z"
			/>
			<path
				fill="#000"
				d="M69.389 14.489c3.307-2.2 14.725-8.43 14.725-8.43l.016.018c-1.957-2.093-5.513-4.165-10.012-4.165-5.533 0-9.347 2.24-9.347 2.24H2.321c0 1.67 2.527 2.947 5.481 2.947h18.16L41.43 17.997v16.306c0 7.079 3.73 13.25 9.832 16.807 6.098 3.557 9.159 3.287 13.65 3.287V23.284c0-2.74.828-6.365 4.477-8.795zm9.858-7.59a1.136 1.136 0 0 1-2.27 0 1.136 1.136 0 0 1 2.27 0zm-14.285 4.72l7.08-3.905 3.113.255-10.193 5.636V11.62z"
			/>
			<path fill="#F0E614" d="M25.963 7.101h26.03c-5.82 0-10.563 4.66-10.563 10.898L25.963 7.1z" />
			<path
				fill="#E60000"
				d="M82.696 6.842c-2.058-1.746-5.297-3.343-9.14-3.343V1.923l.562-.011c4.494 0 8.04 2.061 9.996 4.147l-1.418.783zm.271 3.18L71.688 18.31s-.134-1.212 1.564-2.578c1.696-1.366 11.966-8.233 11.966-8.233l-2.25 2.522z"
			/>
			<path
				fill="#FFF"
				d="M60.174 31.204v-5.545c0-2.33-.954-3.944-3.13-5.478l-9.22-6.493a6.339 6.339 0 0 0-1.66 4.315 6.425 6.425 0 0 0 2.558 5.125l11.452 8.076z"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: {
		/**
		 * unique ID automatically generated if not set
		 */
		id: {
			type: String,
			default: 'id-' + Math.random().toString(36).substr(2, 9),
		},
		/**
		 * there is no reverse version of this, this prop does nothing
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * can be xs, sm, lg, xl, or responsive
		 */
		size: {
			type: String,
			default: null,
		},
	},
	computed: {
		classes() {
			return {
				'LogoLabSapsucker--xs': this.size === 'xs',
				'LogoLabSapsucker--sm': this.size === 'sm',
				'LogoLabSapsucker--lg': this.size === 'lg',
				'LogoLabSapsucker--xl': this.size === 'xl',
				'LogoLabSapsucker--responsive': this.size === 'responsive',
			};
		},
	},
};
</script>

<style lang="scss">
/* --------------------------------
	Lab logo - sapsucker only
-------------------------------- */

/* Original dimensions of svg - used for calculating width from height */
$logo-lab-sapsucker-orig-w: 100;
$logo-lab-sapsucker-orig-h: 58;
/* Units to be used below */
$logo-lab-sapsucker-units: rem;

/* Default logo style */
.LogoLabSapsucker {
	$logo-lab-sapsucker-h-md: 1.75;
	$logo-lab-sapsucker-w-md: calc-width-from-height($logo-lab-sapsucker-orig-w, $logo-lab-sapsucker-orig-h, $logo-lab-sapsucker-h-md);
	height: #{$logo-lab-sapsucker-h-md}#{$logo-lab-sapsucker-units};
	width: #{$logo-lab-sapsucker-w-md}#{$logo-lab-sapsucker-units};
	max-width: 100%; /* Ensure svg will shrink with container */
	vertical-align: middle; /* Safety if width or height are overridden out of ratio */
}

/* ----------------
	Variants
---------------- */

/* Reverse variant for dark backgrounds */
.LogoLabSapsucker--reverse {
	/* No reverse styling needed */
}

/* Extra small (xs) variant */
.LogoLabSapsucker--xs {
	$logo-lab-sapsucker-h-xs: 1.25;
	$logo-lab-sapsucker-w-xs: calc-width-from-height($logo-lab-sapsucker-orig-w, $logo-lab-sapsucker-orig-h, $logo-lab-sapsucker-h-xs);
	height: #{$logo-lab-sapsucker-h-xs}#{$logo-lab-sapsucker-units};
	width: #{$logo-lab-sapsucker-w-xs}#{$logo-lab-sapsucker-units};
}

/* Small (sm) variant */
.LogoLabSapsucker--sm {
	$logo-lab-sapsucker-h-sm: 1.5;
	$logo-lab-sapsucker-w-sm: calc-width-from-height($logo-lab-sapsucker-orig-w, $logo-lab-sapsucker-orig-h, $logo-lab-sapsucker-h-sm);
	height: #{$logo-lab-sapsucker-h-sm}#{$logo-lab-sapsucker-units};
	width: #{$logo-lab-sapsucker-w-sm}#{$logo-lab-sapsucker-units};
}

/* Large (lg) variant */
.LogoLabSapsucker--lg {
	$logo-lab-sapsucker-h-lg: 2;
	$logo-lab-sapsucker-w-lg: calc-width-from-height($logo-lab-sapsucker-orig-w, $logo-lab-sapsucker-orig-h, $logo-lab-sapsucker-h-lg);
	height: #{$logo-lab-sapsucker-h-lg}#{$logo-lab-sapsucker-units};
	width: #{$logo-lab-sapsucker-w-lg}#{$logo-lab-sapsucker-units};
}

/* Extra large (xl) variant */
.LogoLabSapsucker--xl {
	$logo-lab-sapsucker-h-xl: 2.25;
	$logo-lab-sapsucker-w-xl: calc-width-from-height($logo-lab-sapsucker-orig-w, $logo-lab-sapsucker-orig-h, $logo-lab-sapsucker-h-xl);
	height: #{$logo-lab-sapsucker-h-xl}#{$logo-lab-sapsucker-units};
	width: #{$logo-lab-sapsucker-w-xl}#{$logo-lab-sapsucker-units};
}
</style>
